import React from 'react'
import { removeHtml } from '@fs/zion-frontend-friends'
import { getBrowserSeoLocales } from '../helpers'
import StructuredData from './StructuredData'
import { getPersonData } from './PersonStructuredData'
import { getOrganizationData, getRootsTechOrganizationData } from './OrganizationStructuredData'
import { getSaltPalacePlaceData } from './PlaceStructuredData'
import { getVirtualLocationData } from './VirtualLocationStructuredData'
import { getCourseOfferData } from './OfferStructuredData'
import { getCourseInstanceData } from './CourseInstanceStructuredData'

const getCourseInstances = (data, provider, location) => {
  return getBrowserSeoLocales(data.alternateLocales)?.map((locale) => {
    return getCourseInstanceData(data, locale, provider, location)
  })
}

const getSessionLocation = ({ sessionLocation, url }) => {
  const location = []
  if (sessionLocation === 'Online') {
    location.push(getVirtualLocationData(url))
  }
  if (sessionLocation === 'In-Person') {
    location.push(getSaltPalacePlaceData())
  }
  if (sessionLocation === 'In-Person and Online') {
    location.push(getSaltPalacePlaceData(), getVirtualLocationData(url))
  }
  return location
}

export const getCourseData = (data) => {
  const { url, exhibitors } = data
  const provider = exhibitors ? getOrganizationData(exhibitors[0]) : getRootsTechOrganizationData()
  const location = getSessionLocation(data)

  return {
    '@type': 'Course',
    name: data.title,
    description: removeHtml(data.description),
    url: url || '',
    provider,
    offers: getCourseOfferData(data),
    creator: data.creators?.map((creator) => getPersonData(creator)),
    hasCourseInstance: getCourseInstances(data, provider, location),
  }
}

export default function CourseStructuredData({ data }) {
  if (!data || Object.keys(data).length === 0) return null
  const structuredData = getCourseData(data)

  return <StructuredData data={structuredData} dataTestId="course-structured-data" />
}
